export default __webpack_public_path__ + "static/media/Initiate's Boots of the Moon.87892b34.jpg";